
import WithModel from '@/mixins/withModel';
import * as OM from '@/model';
import { mixins, Options, Vue } from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

@Options({})
export default class yesNo extends mixins(WithModel) {

    declare localValue: boolean;

    setAndEmit(val){
        this.localValue = val;
        this.emitModel(this.localValue);
    }

}

